export default "__VITE_ASSET__B5aG0Huk__"